// removed by extract-text-webpack-plugin
module.exports = {"Offers":"Offers__Offers___2kJw1","OffersContent":"Offers__OffersContent___2_Fpy","OffersFiltersTrigger":"Offers__OffersFiltersTrigger___2CFzS","OffersListInfo":"Offers__OffersListInfo___awvYQ","OffersListInfoHideMobile":"Offers__OffersListInfoHideMobile___1n3DB","OffersListHeader":"Offers__OffersListHeader___3_Eow","OffersListHeaderImage":"Offers__OffersListHeaderImage___1W9HR","OffersList":"Offers__OffersList___EWqvx","OffersListZero":"Offers__OffersListZero___uzuhh"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/Offers/Offers.less
// module id = 1191
// module chunks = 0 1